'use client'

/***
 *
 * @file app/not-found.tsx
 * @description NotFound page is used to show message for un-existed data.
 * @author Naveen Kumar
 * @organization Ingka Center
 * @since 13 Feb 2024
 *
 */

import React from "react";
import CustomError from "@/components/CustomError";

const NotFound = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <div data-testid="not-found-main-page" className="error-page">
      <CustomError 
        // heading={t('heading')} 
        // content={t('content')} 
        // link={{url: "/", label: t('linkLabel')}} 

        heading={"Oops! data not found."} 
        content={"But luckily enough we have plenty of other pages full of inspiration and information."} 
        // buttonLabel="Try again"
        link={{url: "/", label: "Back to home"}} 
      />
    </div>
  );
};

export default NotFound;
